import { Subject } from "../models/multiple-question";

const subjects: Subject[] = [
  {
    icon: "Safety",
    name: "An toàn và bảo mật hệ thống thông tin",
    code: "an-toan-va-bao-mat-he-thong-thong-tin",
  },
  {
    icon: "hourglass",
    name: "Kinh tế chính trị Mác - Lênin",
    code: "kinh-te-chinh-tri-mac-lenin",
  },
  {
    icon: "database",
    name: "Cơ sở dữ liệu",
    code: "co-so-du-lieu",
  },
  {
    name: "Tư tưởng Hồ Chí Minh",
    icon: "book",
    code: "tu-tuong-ho-chi-minh",
  },
  {
    icon: "hourglass",
    name: "Phương pháp luận nghiên cứu khoa học",
    code: "phuong-phap-luan-nghien-cuu-khoa-hoc",
  },
  {
    name: "An toàn Web và CSDL",
    icon: "database",
    code: "an-toan-web-va-csdl",
  },
  {
    icon: "ie",
    name: "Mạng máy tính",
    code: "mang-may-tinh",
  },
  {
    name: "Pháp luật đại cương",
    icon: "hourglass",
    code: "phap-luat-dai-cuong",
  },
  {
    name: "Lịch sử Đảng",
    icon: "hourglass",
    code: "lich-su-dang",
  },
];

export default subjects;
